import {INavigationPage} from './iNavigationPage';
import {INavigationPagesService} from './iNavigationPagesService';

export class NavigationPagesService implements INavigationPagesService {
    getNavigationPages(): INavigationPage[] {
        return [
            {
                pageTitle: 'Requests', stateName: 'requests', materialIcon: 'description'
            },
            {
                pageTitle: 'Rules', stateName: 'rules', materialIcon: 'rule'
            }           
        ];
    }
}


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/navigation/navigationPages.service.ts
 **/